import type { SaveStatus } from '@/types/status'

interface SaveStatusIndicatorProps {
  status: SaveStatus
}

const labels: Record<Exclude<SaveStatus, 'idle'>, string> = {
  saving: 'Salvando…',
  saved: 'Salvo agora',
  error: 'Erro ao salvar',
}

export function SaveStatusIndicator({ status }: SaveStatusIndicatorProps) {
  if (status === 'idle') {
    return null
  }

  return (
    <span className={`save-status save-status--${status}`} role="status" aria-live="polite">
      {labels[status]}
    </span>
  )
}
